import { Pipe, PipeTransform } from '@angular/core';
import { ITxFormClientData } from '../model/transaction-form-data.model';

@Pipe({
  name: 'filterCompleteClients',
})
export class FilterCompleteClientsPipe implements PipeTransform {
  transform(clients: ITxFormClientData[], autoIncrementClientId: boolean): ITxFormClientData[] {
    return clients.filter(
      (client) => client.forename && client.surname && (client.personalId || autoIncrementClientId)
    );
  }
}
